// extracted by mini-css-extract-plugin
module.exports = {"container":"_f574eb0","title":"_f8ad955","list":"_e8ddc84","highlight":"_7453fe8"};